import { render, staticRenderFns } from "./ViewPartnerCompanyContainer.vue?vue&type=template&id=b5e4eaea&scoped=true&"
import script from "./ViewPartnerCompanyContainer.vue?vue&type=script&lang=js&"
export * from "./ViewPartnerCompanyContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e4eaea",
  null
  
)

export default component.exports